import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../../typesNew';
import { initialState } from './initialState';

const selectDomain = (state: RootState) => {
  if (state && state.storeState) {
    return state.storeState;
  } else {
    return initialState;
  }
};

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading,
);
export const selectButtonLoading = createSelector(
  [selectDomain],
  (state) => state.buttonLoading,
);
export const selectFormData = createSelector(
  [selectDomain],
  (state) => state.formData,
);
export const selectList = createSelector(
  [selectDomain],
  (state) => state.list,
);
export const selectSearch = createSelector(
  [selectDomain],
  (state) => state.search,
);
export const selectPageNo = createSelector(
  [selectDomain],
  (state) => state.pageNo,
);
export const selectPageSize = createSelector(
  [selectDomain],
  (state) => state.pageSize,
);
export const selectTotalRow = createSelector(
  [selectDomain],
  (state) => state.totalRow,
);

export const selectOrderBy = createSelector(
  [selectDomain],
  (state) => state.orderBy,
);
export const selectOrderDir = createSelector(
  [selectDomain],
  (state) => state.orderDir,
);
export const selectAllCategoryList = createSelector(
  [selectDomain],
  (state) => state.allList,
);
export const selectToggleLoading = createSelector(
  [selectDomain],
  (state) => state.toggleLoading,
);
